<div mat-dialog-title>
  <div class="title-container">
    <div class="title-modal d-flex f-align-center">
      <h1 class="title-modal">
        Create Permission {{ data.isPermissionChild ? 'Child of ' + data.permission.name : '' }}
      </h1>
    </div>
    <span class="icon one-icon-close-v2" (click)="close()"></span>
  </div>

  <div mat-dialog-content>
    <div class="content-container">
      <span>Enter the name:</span>
      <one-input label="Name of permission" [(ngModel)]="inputValue"></one-input>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button class="rp-button rp-outlined rp-primary" (click)="close()">Cancel</button>
  <button class="rp-button rp-filled rp-primary" (click)="create()" [disabled]="inputValue === ''">Create</button>
</div>
